module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 503
// module chunks = 5